import React from 'react'
import GiftCardSelectPage from '../../components/User/GiftCardsSelectPage';

const GiftCardSelectComp = () => {
  return (
    <GiftCardSelectPage />
  )
}

export default GiftCardSelectComp;